import { AvailablePlan } from 'src/pricing/types';
import { formatPrice } from './format-price';

export const calculateMonthlyPrice = (plan?: AvailablePlan) =>
  plan ? formatPrice(plan.monthly.price) : '';
